import { Link } from "react-router-dom";
import { dateFormatter } from "../../BuyerProfile";

export const columns = (
  setShowModal,
  setSelectedBusiness,
  tableParams,
  t,
  cancelRepRequest,
  businessAsignHandler
) => {
  return [
    {
      title: "S.NO",
      dataIndex: "id",
      sorter: true,
      width: "5%",
      render: (text) => <h5>{text}</h5>,
      // tableParams.current
      //   ? index + 1 + (tableParams.current - 1) * tableParams.pageSize
      //   : index + 1,
    },
    {
      title: t("name"),
      dataIndex: "name",
      sorter: true,
      width: "20%",
      render: (text, record) => (
        <div>
          <h5>{record.name}</h5>
          <small>{record.description}</small>
        </div>
      ),
    },
    {
      title: t("domainInput"),
      dataIndex: "domain",
      sorter: true,
      width: "20%",
    },
    {
      title: t("type"),
      dataIndex: "type",
      sorter: true,
      width: "20%",
    },
    {
      title: t("sellingDeadline"),
      dataIndex: "selling_deadline",
      sorter: true,
      width: "20%",
      render: (text) => dateFormatter(text),
    },
    {
      title: t("createdAt"),
      dataIndex: "created_at",
      width: "20%",
      render: (text) => dateFormatter(text),
    },
    {
      title: t("actions"),

      dataIndex: "active",
      render: (text, record) => {
        return (
          <div className="d-flex action-button">
            <Link to={`/assignbusiness/${record?.id}`} className="text-black">
              <button
                className="btn btn-info btn-xs light px-2.5 me-2"
                onClick={() => {
                  setSelectedBusiness(record);
                  setShowModal(true);
                }}
                title={t("viewDetails")}
              >
                <i className="fa fa-eye fs-4"></i>
              </button>
            </Link>
            <button
              className="btn btn-success btn-xs light px-2.5 me-2"
              onClick={() => {
                businessAsignHandler(record?.id);
              }}
              title={t("accept")}
            >
              Accept
            </button>
            <button
              className="btn btn-danger btn-xs light px-2.5 me-2"
              onClick={() => {
                cancelRepRequest(record?.id);
              }}
              title={t("reject")}
            >
              Reject
            </button>
          </div>
        );
      },
      width: "20%",
    },
  ];
};
